export default "__VITE_ASSET__B30tAA5d__"